<div class="chatbot-container" [hidden]="!isAlexChatBotAllowed">
  <df-messenger
    location="australia-southeast1"
    [attr.project-id]="projectId"
    [attr.agent-id]="agentId"
    language-code="en"
    max-query-length="-1"
    url-allowlist="*"
    allow-feedback = "all"
  >
    <df-messenger-chat-bubble
      chat-title="Ask Alex"
      chat-icon="/assets/images/Alex/Alex-beta.svg"
      chat-title-icon="/assets/images/Alex/Alex-beta.svg"
      placeholder-text="Ask, Write or Search for anything..."
      chat-collapse-icon="/assets/images/Alex/collapse-icon.png"
    ></df-messenger-chat-bubble>
  </df-messenger>

  <!-- Feedback popup -->
  <div *ngIf="isPopupOpen" class="popup-overlay">
    <div class="popup-content">
      <div class="popup-header">
        <p>Share Your Feedback</p>
        <button (click)="closePopup()" class="close-icon">
          <img src="/assets/images/Alex/close.svg" alt="cancel" width="16">
        </button>
      </div>
      <div class="popup-details">
        <p>Have suggestions? We'd love to hear them!</p>
        <textarea placeholder="Write your feedback here..." [(ngModel)]="feedbackText"></textarea>
      </div>
      <div class="popup-buttons">
        <button (click)="closePopup()" class="btn-later">Maybe Later</button>
        <button (click)="submitFeedback()" class="btn-submit">Submit Feedback</button>
      </div>
    </div>
  </div>
</div>


